import React from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../AbstractElements';
import { SaleCardData2 } from '../../../Data/Widgets/Chart';
import BrowserUsesChart from './BrowserUsesChart';
import FinanceChart from './FinanceChart';
import LiveProductionChart from './LiveProductionChart';
import MarketingExpenses from './MarketingExpenses';
import MonthlySalesChart from './MonthlySalesChart';
import OrderStatus2 from './OrderStatus';
import OrderStatusChart from './OrderStatusChart';
import SaleChart from './SaleChart';
import SkillStatusChart from './SkillStatusChart';
import TotalEarningChart from './TotalEarningChart';
import TurnoverChart from './TurnoverChart';
import UsesChart from './UsesChart';

const ChartContain = () => {
  return (
    <>
      <Container fluid={true}>
        <Breadcrumbs justify='end' pageTitle='Chart' parent='Widgets' title='Chart' />
        <Row>
          {SaleCardData2.map((item, i) => (
            <SaleChart cardData={item} key={i} />
          ))}
          <MarketingExpenses />
          <TotalEarningChart />
          <SkillStatusChart />
          <OrderStatusChart />
          <LiveProductionChart />
          <TurnoverChart />
          <MonthlySalesChart />
          <UsesChart />
          <BrowserUsesChart />
          <FinanceChart />
          <OrderStatus2 />
        </Row>
      </Container>
    </>
  );
};

export default ChartContain;
